import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ScreenSizeService } from 'src/app/services/screen-size.service';
import { StorageService } from 'src/app/services/storage.service';
import { MenuModalComponent } from '../menu-modal/menu-modal.component';
import { NavSubMenuComponent } from '../nav-sub-menu/nav-sub-menu.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {

  mobileSize: boolean = false;
  loggedIn: boolean = false;
  urlPath: any;
  userObj: any;
  menuToggle:boolean=false;
  access_token: string;
  showToggle:boolean=true;
  showToggleClose:boolean=false;
  constructor(
    private _screenSize: ScreenSizeService,
    private router: Router,
    private strg: StorageService,
    private authService: AuthenticationService,
    public modalController: ModalController,
    public popoverController: PopoverController
  ) { 
    this._screenSize.checkScreenSize().subscribe(res => {
      if(res === "sizeXS" || res === "sizeSM"){
        this.mobileSize = true;
      } else {
        this.mobileSize = false;
      }
    });
    this.authService.authState.subscribe(res => { this.loggedIn = res; });

    this.strg.getStoreData("userObj").then(res=>{
      this.userObj = res;
    });
    
    this.strg.getStoreData("insAccessToken").then(res=>{
      this.access_token = res;
    });

  }

  ngOnInit() {
    this.urlPath = this.router.url;
  }

  claimClicked(){
    window.open("https://www.mypolicyjunction.com/claim.html", "_self");
  }

  landingClicked(){
    window.open("https://www.mypolicyjunction.com/index.html", "_self");
  }

  quoteClicked(){
    window.open("https://www.mypolicyjunction.com/termins.html", "_self");
  }

  openQuoteModal(){
    this.menuToggle = true;
  }

  renewalClicked(){
    window.open("https://www.mypolicyjunction.com/renewal.html", "_self");
  }

  homeClicked(){
    this.router.navigate(['/home/dashboard']);
  }

  signInClicked(){
    this.router.navigate(['/login']);
  }

  signUpClicked(){
    this.router.navigate(['/register']);
  }

  logoutClicked(){
    this.authService.revokeAuthTokenOnLogout(this.access_token, this.userObj.id).subscribe(ress => {
      this.strg.removeStoreData("insAccessToken").then(res => {
        this.strg.removeStoreData("insRefreshToken").then(res => {
          this.strg.removeStoreData("userObj").then(res => {
            this.authService.authState.next(false);
            // this.router.navigate(['/login']);
            // this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url }});
            window.open("https://www.mypolicyjunction.com/", "_self");
            this.loggedIn =  this.authService.isAuthenticated();
          });
        });
      });
    });
  }
  async toggleOpen(){
    const modal = await this.modalController.create({
      component: MenuModalComponent,
      cssClass: 'my-custom-class'
    });
    this.showToggle=false;
    this.showToggleClose=true;
    modal.onDidDismiss().then((isOkay) => {
      this.showToggle=true;
      this.showToggleClose=false;
    });
    return await modal.present();
  }
  async dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
   await this.modalController.dismiss({
      'dismissed': true
    });
    this.showToggle=true;
    this.showToggleClose=false;
  }

  popover: any;

  async presentPopover(ev?: any) {
    const isPopOverOpened = await this.popoverController.getTop();
    if(!isPopOverOpened || isPopOverOpened === undefined){
      this.popover = await this.popoverController.create({
        component: NavSubMenuComponent,
        cssClass: 'popover-class',
        // event: ev,
        translucent: false,
        showBackdrop: true
      });
      await this.popover.present().then(res=>{
        this.menuToggle = true;
      });
      
      const { role } = await this.popover.onDidDismiss().then(res => {
        this.menuToggle = false;
      });
    }
  }
  
}
